import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
export default function Loader(props) {
    return (_jsx(Container, { className: `${props.className || ''} ui-loader`, children: _jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 180 162.1", width: props.size || '3em', children: [_jsx("mask", { id: "myClip", children: _jsx(St1, { points: "177,167.6 48.4,6.5 137,6.5 10.4,156.5 141.7,156.5 91.5,94.6 54.9,135.8 110.2,135 " }) }), _jsx("path", { mask: "url(#myClip)", d: "M108.6,140.9l-8.3-10.4L67,130.4l24.7-28.3l19.2,24.9l16.5,20.7h-0.1l3,3.8L22.4,151l69.3-82.3l74.1,93.4h13.4L98.3,60.5L149.1,0H36.9l48,60.3L0,161.3l151.9,0.7L91.6,86l-47.5,54.5 M58.6,10.5h68.1l-35,41.7L58.6,10.5z" })] }) }));
}
const dash = keyframes `
  to {
    stroke-dashoffset: 0;
  }
`;
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  
  width: 100%;
  height: 100%;

  svg {
    fill: var(--text-primary);
  }
`;
const St1 = styled.polyline `
  fill: none;
  stroke: #fff;
  stroke-width: 10.8;
  stroke-miterlimit: 10;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: ${dash} 1.5s linear infinite;
`;
